module.exports = __webpack_public_path__ + "static/media/icon-access2.37c8abe3.svg";